// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1sw0f","legacyBtn":"MutateMid_legacyBtn__3YbFN"};